// extracted by mini-css-extract-plugin
export default {"methodologyDiv":"OurMethodology_methodologyDiv__6rd9h","data":"OurMethodology_data__Q0I5J","title":"OurMethodology_title__X+CSE","bg":"OurMethodology_bg__4FcQe"};